import { render, staticRenderFns } from "./SocialSecurityGroupSetting.vue?vue&type=template&id=00b96808"
import script from "./SocialSecurityGroupSetting.vue?vue&type=script&lang=js"
export * from "./SocialSecurityGroupSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports